import { appListColumn } from './columns';
import React, { useState } from 'react';
import BuzzTable from '../../../components/BuzzTable/BuzzTable';
// import _ from 'lodash';
import { toast } from 'react-toastify';
import {
  Box,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getAllAppListRouteAsync } from './AppListStore/appListStoreSlice';
import SHAmodal from './AppListStore/SHAmodal';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import BuzzPagination from '../../../components/BuzzPagination/BuzzPagination';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';

const STATUS_OPTION = [
    { label: 'Pending', value: 'pending' },
    { label: 'Approve', value: 'approved' },
    { label: 'Rejected', value: 'rejected' },
  ];

const AppsListDash = () => {
	const [search, setSearch] = useState('');
	const [openModal, setOpenModal] = useState(false);
	 const [page, setPage] = useState(1);
	 const [status, setStatus] = useState('pending');

  const dispatch = useDispatch();
  const { listapps, totalapps } = useSelector((state) => {
    const { appListReducer } = state;

    return {
      listapps: appListReducer.listapps,
			totalapps:appListReducer.totalapps.total,
			// allAppTotal: appListReducer.listapps? appListReducer.listapps.total:null
    };
  });

	console.log('totalNumber5555555555',totalapps)

  React.useEffect(() => {
    fetchData();
		// dispatch(getAllAppListRouteAsync({ page: 1, limit: 10 }));
  }, []);

  const fetchData = async () => {
    try {
      dispatch(getAllAppListRouteAsync({ page: 1, limit: 10 }))
        .unwrap()
        .then(() => {
          toast.success('All apps list were fetched successfully!');
        });
    } catch (error) {
      toast.error('apps list could not be fetched. Please try again!');
    }
  };
console.log('testting data',listapps)
	const handlePageChange = (val) => {
    if (val !== page) {
      setPage(val);
      dispatch(
        getAllAppListRouteAsync({
          page: val,
          limit: 10,
          // schoolName,
          // city,
          // sort,
        })
      )
        .unwrap()
        .then((res) => {
          if (res && res.status > 299) {
            toast.success('All apps list were fetched successfully!');
          }
        })
        .catch((err) => {
          toast.error('apps list could not be fetched. Please try again!');
        });
    }
  }

	const handleSearchPackage = () => {
    // API call
    dispatch(
      getAllAppListRouteAsync({
        page: 1,
        limit: 8,
        search,
        // city,
        // sort,
      })
    )
      .unwrap()
      .then((res) => {
        if (res && res.status > 299) {
          toast.error(`failed to search`);
        }
      })
      .catch((err) => {
        toast.error(`failed to search`);
      });
  };

	// const handleStatus = (e) => {
  //   console.log({ e: e.target.value });
  //   setStatus(e.target.value);
  //   dispatch(getAllAppListRouteAsync(e.target.value));

  //   if (packageName !== '') {
  //     dispatch(
  //       getAllAppListRouteAsync({
  //         params: {
  //           // entityType: 'kyc',
  //           // approvalType: 'user-kyc-status',
  //           // limit: PER_PAGE,
  //           page: 1,
  //           status: [e.target.value],
  //           secondaryFilter: { userId: packageName },
  //         },
  //         type: 'userKyc',
  //       })
  //     );
  //   } else {
  //     dispatch(
  //       getAllAppListRouteAsync({
  //         params: {
  //           entityType: 'kyc',
  //           approvalType: 'user-kyc-status',
  //           // limit: PER_PAGE,
  //           page: 1,
  //           statuses: [e.target.value],
  //         },
  //         type: 'userKyc',
  //       })
  //     );
  //   }
  // };

	const handleStatus = (e) => {
		setStatus(e.target.value);
    // API call
    dispatch(
      getAllAppListRouteAsync({
        page: 1,
        limit: 8,
        // search,
				status: [e.target.value],
        // city,
        // sort,
      })
    )
      .unwrap()
      .then((res) => {
        if (res && res.status > 299) {
          toast.error(`failed to search`);
        }
      })
      .catch((err) => {
        toast.error(`failed to search`);
      });
  };

  return (
    <Box>
      <Box mb={2} display={'flex'} maxWidth={700}>
				<Box>
        <BuzzInput
				width={480}
          placeholder={'Search by package name'}
          search
          flex={2}
          mr={2}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          size="small"
          onSubmitEditing={handleSearchPackage}
        />
				</Box>
				<Box>
          <BuzzSelect
            width={180}
            name="status"
            size={'small'}
            placeholder={'Select status'}
            value={status}
            onChange={handleStatus}
            // label="Select status"
            valueKey="value"
            labelKey="label"
            options={STATUS_OPTION}
          />
        </Box>
      </Box>
      <Box my={4}>
        <BuzzTable 
				columns={appListColumn} 
				data={listapps}
				
				/>
				<Box display="flex" justifyContent="center">
          <BuzzPagination
            onClick={handlePageChange}
            total={totalapps}
            pageNo={page}
            defaultPage={1}
            perPage={8}
          />
        </Box>
      </Box>
			<SHAmodal
            open={openModal}
            onClose={() => {
              setOpenModal(false);
            }}
          />
    </Box>
  );
};

export default AppsListDash;

